import { z } from 'zod';

// Caption schema for word-level timing
export const CaptionWordSchema = z.object({
  text: z.string(),
  startMs: z.number(),
  endMs: z.number(),
});

export const CaptionSchema = z.object({
  words: z.array(CaptionWordSchema),
});

// Main MetaAd props schema
export const MetaAdPropsSchema = z.object({
  // Content
  script: z.string().default(''),
  voiceoverUrl: z.string().optional(),
  voiceoverVolume: z.number().min(0).max(1).default(0.6),
  captions: CaptionSchema.optional(),

  // Background
  backgroundType: z.enum(['color', 'image', 'video']).default('color'),
  backgroundUrl: z.string().optional(),
  backgroundColor: z.string().default('#1a1a2e'),

  // Text overlays
  headline: z.string().optional(),
  ctaText: z.string().optional(),

  // Styling
  captionStyle: z.object({
    fontFamily: z.string().default('Inter'),
    fontSize: z.number().default(48),
    color: z.string().default('#ffffff'),
    highlightColor: z.string().default('#ffd700'),
    position: z.enum(['top', 'center', 'bottom']).default('center'),
    backgroundColor: z.string().optional(),
  }).prefault({}),

  // Animation settings
  captionAnimation: z.enum(['none', 'word-highlight', 'word-pop', 'karaoke']).default('word-highlight'),

  // Video settings
  aspectRatio: z.enum(['1:1', '4:5', '9:16', '16:9']).default('1:1'),
  durationInFrames: z.number().default(300),
});

export type CaptionWord = z.infer<typeof CaptionWordSchema>;
export type Caption = z.infer<typeof CaptionSchema>;
export type MetaAdProps = z.infer<typeof MetaAdPropsSchema>;

// Aspect ratio dimensions
export const ASPECT_RATIOS = {
  '1:1': { width: 1080, height: 1080 },
  '4:5': { width: 1080, height: 1350 },
  '9:16': { width: 1080, height: 1920 },
  '16:9': { width: 1920, height: 1080 },
} as const;

// Default props for each aspect ratio
export const getDefaultProps = (aspectRatio: '1:1' | '4:5' | '9:16' | '16:9'): MetaAdProps => ({
  script: '',
  voiceoverVolume: 0.6,
  backgroundType: 'color',
  backgroundColor: '#1a1a2e',
  captionStyle: {
    fontFamily: 'Inter',
    fontSize: aspectRatio === '9:16' ? 56 : aspectRatio === '16:9' ? 42 : 48,
    color: '#ffffff',
    highlightColor: '#ffd700',
    position: 'center',
  },
  captionAnimation: 'word-highlight',
  aspectRatio,
  durationInFrames: 300,
});

// Composition names
export const COMP_NAMES = {
  FEED_SQUARE: 'MetaAd-Feed-Square',
  FEED_PORTRAIT: 'MetaAd-Feed-Portrait',
  REELS: 'MetaAd-Reels',
  LANDSCAPE: 'Video-Landscape',
} as const;

// Video settings
export const VIDEO_FPS = 30;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
